import { addIntentTo } from '@ff-os/shared-utils/asset-urls';
import { createAuthorizationHeader, parseDescriptor } from '@ff-os/shared-utils/private-urls';
import { AsyncCache } from './AsyncCache';
import { blobUrlStore } from './blobUrlStore';

class PrivateImageCache extends AsyncCache<string, string> {

    constructor(expireAfterMs: number = 60000) {
        super();
        setInterval(() => this.gc(expireAfterMs), 5000);
    }

    protected toKey = (descriptor: string) => {
        return parseDescriptor(descriptor).url;
    };

    protected load = async (parameters: string): Promise<string> => {

        const { url, jwt } = parseDescriptor(parameters);

        const urlWithIntent = addIntentTo(url, 'web');

        const response = await fetch(urlWithIntent, {
            mode: 'cors',
            headers: createAuthorizationHeader(jwt)
        });

        if (!response.ok) {
            throw new Error(`Authentication error: ${urlWithIntent} [${response.status}]`);
        }

        const blobUrl = URL.createObjectURL(await response.blob());
        blobUrlStore.track(blobUrl);
        return blobUrl;
    };
}

export const privateImageCache = new PrivateImageCache();